// login
export const LOGIN_RESPONSE = 'LOGIN_RESPONSE';

// loader
export const HANDLE_LOADER = 'HANDLE_LOADER';

// ForgotPassword
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';

// TriageSetupBasicInfo
export const TRIAGE_BASIC_INFO = 'TRIAGE_BASIC_INFO';

// GetState
export const GET_STATE_ALL = 'GET_STATE_ALL';

// City
export const GET_CITY = 'GET_CITY';

// GET_TIMEZONE
export const GET_TIMEZONE_ALL = 'GET_TIMEZONE_ALL';

// RingGroup List
export const RING_GROUP_LIST = 'RING_GROUP_LIST';

// ivr list
export const IVR_LIST = 'IVR_LIST';

export const HOSPITAL_LIST = 'HOSPITAL_LIST';

export const HOSPITAL_LIST_CHAIN = 'HOSPITAL_LIST_CHAIN';

// audio list
export const AUDIO_LIST = 'AUDIO_LIST';

// Triage_Type
export const TRIAGE_TYPE = 'TRIAGE_TYPE';

export const SET_HOSPITAL_RING_REL = 'SET_HOSPITAL_RING_REL';

export const SET_HOSPITAL_IVR_REL = 'SET_HOSPITAL_IVR_REL';

// DocumentSetting
export const DOCUMENT_SETTING = 'DOCUMENT_SETTING';

// searched number response
export const SEARCH_NUMBER_RESPONSE = 'SEARCH_NUMBER_RESPONSE';

// fetch all the hospitals
export const GET_HOSPITALS_ALL = 'GET_HOSPITALS_ALL';

// to clear all hospital
export const CLEAR_ALL_HOSPITALS = 'CLEAR_ALL_HOSPITALS';

// updated status success
export const UPDATE_STATUS_HOSPITAL_SUCCESS = 'UPDATE_STATUS_HOSPITAL_SUCCESS';

// search hospital
export const GET_SEARCHED_HOSPITALS_ALL = 'GET_SEARCHED_HOSPITALS_ALL';

// set current hospital
export const SET_CURRENT_HOSPITAL = 'SET_CURRENT_HOSPITAL';

// delete hospital
export const DELETE_HOSPITAL = 'DELETE_HOSPITAL';

// set WELCOMEPAGE DATa
export const SET_WELCOME_MESSAGE_DATA = 'SET_WELCOME_MESSAGE_DATA';

// set set actions option for ivr DATa
export const SET_KEY_ACTION_DATA = 'SET_KEY_ACTION_DATA';

// set chain list
export const GET_CHAINS_ALL = 'GET_CHAINS_ALL';

export const GET_SEARCHED_CHAINS_ALL = 'GET_SEARCHED_CHAINS_ALL';

export const CREATE_CHAIN_ADD = 'CREATE_CHAIN_ADD';

export const CLEAR_HOSPITAL_ONBOARD = 'CLEAR_HOSPITAL_ONBOARD';

// upload recordings from recordings view recordings page
export const UPLOAD_RECORDING = 'UPLOAD_RECORDING';

export const DELETE_RECORDING = 'DELETE_RECORDING';

// get All the Recordings
export const GET_RECORDING_LISTS = 'GET_RECORDING_LISTS';

// set Ring Group acc to offset
export const SET_RING_GROUP_LIST = 'SET_RING_GROUP_LIST';

// created Ring Group global
export const CREATED_RING_GROUP = 'CREATED_RING_GROUP';

// set IVR acc to offset
export const SET_IVR_LIST = 'SET_IVR_LIST';

// Nurse Management
export const GET_NURSES_ALL = 'GET_NURSES_ALL';

export const GET_SEARCHED_NURSES_ALL = 'GET_SEARCHED_NURSES_ALL';

// created IVR global
export const CREATED_IVR = 'CREATED_IVR';

export const CREATE_NURSE_ADD = 'CREATE_NURSE_ADD';

// updated status success nurse
export const UPDATE_STATUS_NURSE_SUCCESS = 'UPDATE_STATUS_NURSE_SUCCESS';

// set nurse by id
export const SET_NURSE_BY_ID = 'SET_NURSE_BY_ID';

// create roles
export const SET_ROLES_LIST = 'SET_ROLES_LIST';

// set roles list with permissions
export const SET_ROLES_WITH_PERM_LIST = 'SET_ROLES_WITH_PERM_LIST';

// get nurse roles list with permissions
export const GET_NURSE_ROLES_WITH_PERM = 'GET_NURSE_ROLES_WITH_PERM';

// get FAQ's Q&A
export const GET_QUESTION = 'GET_QUESTION';

// get Help and Support Contact and email
export const GET_CONTACT = 'GET_CONTACT';
export const GET_EMAIL = 'GET_EMAIL';

// get market outreach
export const GET_MARKET_OUTREACH = 'GET_MARKET_OUTREACH';

// get GV Fee
export const GET_GV_FEE = 'GET_GV_FEE';

// dashboard types
export const SET_DASHBOARD_ALL_DATA_COUNT = 'SET_DASHBOARD_ALL_DATA_COUNT';
export const SET_CASES_COUNT_WEEK = 'SET_CASES_COUNT_WEEK';
export const SET_CASES_COUNT_MONTH = 'SET_CASES_COUNT_MONTH';
export const SET_CASES_COUNT_YEAR = 'SET_CASES_COUNT_YEAR';
export const SET_CLIENTS_COUNT_MONTH = 'SET_CLIENTS_COUNT_MONTH';
export const SET_CUSTOMER_FEEDBACK = 'SET_CUSTOMER_FEEDBACK';
export const SET_PREFERENCES_ALL_VALUES = 'SET_PREFERENCES_ALL_VALUES';
export const SET_TOP_ISSUES = 'SET_TOP_ISSUES';
export const SET_CALLS_COUNT = 'SET_CALLS_COUNT';
export const SET_START_END_DATE = 'SET_START_END_DATE';
export const RESET_DASHBOARD_DATA = 'RESET_DASHBOARD_DATA';
export const GET_ALL_HOSPITAL_LIST = 'GET_ALL_HOSPITAL_LIST';
export const SET_PAYMENT_CALCULATION = 'SET_PAYMENT_CALCULATION';
export const SET_TELE_MED_TOP_ISSUES = 'SET_TELE_MED_TOP_ISSUES';
export const SET_AVG_CONSULATION_PRICE = 'SET_AVG_CONSULATION_PRICE';
export const SET_DVM_USED_APP_COUNT = 'SET_DVM_USED_APP_COUNT';
export const SET_USER_CREATED_PROFILECOUNT = 'SET_USER_CREATED_PROFILECOUNT';
export const SET_APPOINTMENT_DVM_MONTH = 'SET_APPOINTMENT_DVM_MONTH';
export const SET_CURBSIDE_ANALYTICS = 'SET_CURBSIDE_ANALYTICS';

// gv-timing types
export const SET_CLINIC_HOURS_EVENTS = 'SET_CLINIC_HOURS_EVENTS';
export const RESET_SETUP_SCHEDULE_DATA = 'RESET_SETUP_SCHEDULE_DATA';
export const SET_CLINIC_HOURS_TIMEZONE = 'SET_CLINIC_HOURS_TIMEZONE';
export const SET_SETUP_SCHEDULE_MODAL_VISIBILITY =
  'SET_SETUP_SCHEDULE_MODAL_VISIBILITY';
export const SET_INITIAL_DATE_CLINIC_HOURS = 'SET_INITIAL_DATE_CLINIC_HOURS';
export const SET_SETUP_SCHEDULE_EDIT_STATE = 'SET_SETUP_SCHEDULE_EDIT_STATE';
export const SET_SETUP_SCHEDULE_DATE_CLICKED_STATE =
  'SET_SETUP_SCHEDULE_DATE_CLICKED_STATE';
export const UPDATE_SETUP_SCHEDULE_DATA = 'UPDATE_SETUP_SCHEDULE_DATA';
export const CLEAR_STATE_REDUX = 'CLEAR_STATE_REDUX';

// payments
export const SET_PAYMENT_LISTING = 'SET_PAYMENT_LISTING';
export const SET_HOSPITAL_DVM_LISTING = 'SET_HOSPITAL_DVM_LISTING';
export const SET_HOSPITAL_CONSULT_LISTING = 'SET_HOSPITAL_CONSULT_LISTING';
export const SET_START_END_DATE_PAYMENT = 'SET_START_END_DATE_PAYMENT';
export const GET_ALL_HOSPITAL_LIST_PAYMENT = 'GET_ALL_HOSPITAL_LIST_PAYMENT';

// gv-greetings types
export const GET_GREETINGS = 'GET_GREETINGS';
export const CLEAR_GREETINGS = 'CLEAR_GREETINGS';

// commnication logs
export const GET_ALL_HOSPITAL_LIST_COMM = 'GET_ALL_HOSPITAL_LIST_COMM';
export const SET_START_END_DATE_COMM_LOG = 'SET_START_END_DATE_COMM_LOG';
export const SET_COMM_LOGS = 'SET_COMM_LOGS';

export const GET_CALL_MATRIX_INIT = 'GET_CALL_MATRIX_INIT';
export const GET_CALL_MATRIX_SUCCESS = 'GET_CALL_MATRIX_SUCCESS';
export const GET_CALL_MATRIX_FAILURE = 'GET_CALL_MATRIX_FAILURE';

// call notifications types
export const SET_CALL_NOTIFICATIONS_LIST = 'SET_CALL_NOTIFICATIONS_LIST';
export const SET_CALL_NOTIFICATIONS_MINUTES = 'SET_CALL_NOTIFICATIONS_MINUTES';

// on call protocol get Referral Hospital Information of hospital
export const SET_ON_CALL_PROTOCOL = 'SET_ON_CALL_PROTOCOL';
export const GET_REFERRAL_HOSPITAL_INFORMATION =
  'GET_REFERRAL_HOSPITAL_INFORMATION';
export const POST_REFERRAL_HOSPITAL_INFORMATION =
  'POST_REFERRAL_HOSPITAL_INFORMATION';
export const UPDATE_REFERRAL_HOSPITAL_INFORMATION =
  'UPDATE_REFERRAL_HOSPITAL_INFORMATION';

// master records types
export const SET_SPECIES_MASTER_LIST = 'SET_SPECIES_MASTER_LIST';
export const SET_BREEDS_MASTER_LIST = 'SET_BREEDS_MASTER_LIST';
export const SET_GENDERS_MASTER_LIST = 'SET_GENDERS_MASTER_LIST';
export const SET_STATES_MASTER_LIST = 'SET_STATES_MASTER_LIST';
export const SET_TIMEZONES_MASTER_LIST = 'SET_TIMEZONES_MASTER_LIST';
export const SET_CHIEF_COMPLAINTS_MASTER_LIST =
  'SET_CHIEF_COMPLAINTS_MASTER_LIST';

// new dashboard types
export const SET_DIRECT_REVENUE_COUNT = 'SET_DIRECT_REVENUE_COUNT';
export const SET_IN_DIRECT_REVENUE_COUNT = 'SET_IN_DIRECT_REVENUE_COUNT';
export const SET_NEW_CLIENTS_COUNT = 'SET_NEW_CLIENTS_COUNT';
export const SET_CONSULTATION_COUNT = 'SET_CONSULTATION_COUNT';
export const SET_SCHEDULED_APPOINTMENT_COUNT =
  'SET_SCHEDULED_APPOINTMENT_COUNT';
export const SET_ER_REFS_COUNT = 'SET_ER_REFS_COUNT';
export const SET_ANALYTICS_COUNT_DATE_RANGE = 'SET_ANALYTICS_COUNT_DATE_RANGE';

export const SET_TOP_PERFORMING_DVM_LIST_DATA =
  'SET_TOP_PERFORMING_DVM_LIST_DATA';
export const SET_DIRECT_REVENUE_LIST = 'SET_DIRECT_REVENUE_LIST';
export const SET_IN_DIRECT_REVENUE_LIST = 'SET_IN_DIRECT_REVENUE_LIST';
export const SET_TOP_PERFORMING_DVM_DATE_RANGE =
  'SET_TOP_PERFORMING_DVM_DATE_RANGE';
export const SET_TRIAGE_TELEMED_DATE_RANGE = 'SET_TRIAGE_TELEMED_DATE_RANGE';
export const SET_AVG_FEEDBACK_DVM = 'SET_AVG_FEEDBACK_DVM';
export const SET_AVG_FEEDBACK_DVM_DATE_RANGE =
  'SET_AVG_FEEDBACK_DVM_DATE_RANGE';
export const SET_CLIENT_FEEDBACK_FOR_DVM = 'SET_CLIENT_FEEDBACK_FOR_DVM';
export const SET_CLIENT_PERCENTAGE = 'SET_CLIENT_PERCENTAGE';
export const SET_TOTAL_REVENUE_GENERATED = 'SET_TOTAL_REVENUE_GENERATED';
export const SET_TRIAGE_TELEMED_FEEDBACK = 'SET_TRIAGE_TELEMED_FEEDBACK';
export const SET_CALL_VOLUME_BY_DAY = 'SET_CALL_VOLUME_BY_DAY';
export const SET_CALL_VOLUME_BY_HOUR = 'SET_CALL_VOLUME_BY_HOUR';
export const SET_CALL_VOLUME_DATE_RANGE = 'SET_CALL_VOLUME_DATE_RANGE';
export const RESET_NEW_DASHBOARD_DATA = 'RESET_NEW_DASHBOARD_DATA';
export const SET_HOSPITALS = 'SET_HOSPITALS';
export const SET_PETCO_WEB_VISIT_ANALYTICS = 'SET_PETCO_WEB_VISIT_ANALYTICS';
export const SET_CHAINED_HOSPITALS = 'SET_CHAINED_HOSPITALS';

export const SET_CHAINED_HOSPITALS_COMM_LOG = 'SET_CHAINED_HOSPITALS_COMM_LOG';
export const SET_ACTIVE_USERS_IN_APP = 'SET_ACTIVE_USERS_IN_APP';
export const SET_TOTAL_APP_USERS = 'SET_TOTAL_APP_USERS';
export const SET_USERS_IN_APP_DATE_RANGE = 'SET_USERS_IN_APP_DATE_RANGE';
